import React from 'react';
import Link from 'next/link';

export interface Crumb {
  name: string;
  /** Root-relative href. Omit for the current (last) item. */
  href?: string;
}

/**
 * Visual breadcrumb trail. Pair with generateBreadcrumbSchema() for the
 * matching JSON-LD (rendered separately via <JsonLd>).
 */
export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm">
      <ol className="flex flex-wrap items-center gap-1.5 text-gray-400">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {item.href && !isLast ? (
                <Link href={item.href} className="hover:text-purple-300 transition-colors">
                  {item.name}
                </Link>
              ) : (
                <span className={isLast ? 'text-gray-200 font-medium' : ''} aria-current={isLast ? 'page' : undefined}>
                  {item.name}
                </span>
              )}
              {!isLast && (
                <svg className="w-3.5 h-3.5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
